import React from 'react';

import { IconTooltip } from 'utils/components/IconTooltip';

import './LiquiditySummaryChartHelp.scss';
import { LiquiditySummaryChartIllustration } from 'widgets/liquiditySummary/help/LIquiditySummaryChartIllustration';

export default function LiquiditySummaryChartHelp() {
    return (
        <IconTooltip className="LiquiditySummaryChartHelp">
            <div>
                This chart compares today&apos;s actual market volume to the
                historical market average, while also showing you estimates of
                your order&apos;s leaves in relation to the forecasted rest of
                day and closing auction volumes.
            </div>
            <LiquiditySummaryChartIllustration dimRem={true} />
            <div className="open-to-now">
                From open until now, total market actual volume traded vs the
                historical average.
            </div>
            <LiquiditySummaryChartIllustration dimVol={true} dimRem={true} />
            <div className="todays-adj">
                <span className="title">Today&apos;s Adj</span>
                Overall, is today&apos;s volume higher or lower than the
                historical average.
            </div>
            <LiquiditySummaryChartIllustration dimVol={true} />
            <div className="now-to-close">
                The rest of day&apos;s predicted volume, based on historical
                volume and today&apos;s adjustment.
            </div>
            <div>
                Historical market volume is the total volume, both auctions
                continuous within day trading.
            </div>
            <div className="auction-bars">
                <div className="auction-bar open" />
                <div className="vol" />
                <div className="auction-bar close" />
            </div>
            <div className="auction-text">
                <div>Open Auction</div>
                <div>Close Auction</div>
            </div>
        </IconTooltip>
    );
}
